<template>
    <div class="row">
        <div class="col-sm-12">
            <form @submit.prevent="validateBeforeSubmit">
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="code">{{ $t('branches.code') }}</label>
                        <div class="col-sm-5">
                            <input :class="{'form-control':true, 'is-invalid': errors.has('code') }"
                                   id="code"
                                   name="code"
                                   type="text"
                                   maxlength="10"
                                   :placeholder="$t('branches.code_placeholder')"
                                   v-model="form.code" v-validate="'required|max:10'">
                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('code')"/>
                                <span v-show="errors.has('code')">{{ errors.first('code') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="description">{{ $t('branches.description') }}</label>
                        <div class="col-sm-5">
                            <input :class="{'form-control':true, 'is-invalid': errors.has('description') }"
                                   id="description"
                                   name="description"
                                   type="text"
                                   :placeholder="$t('branches.description_placeholder')"
                                   v-model="form.description" v-validate="'required'">
                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('description')"/>
                                <span v-show="errors.has('description')">{{ errors.first('description') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="country_id">{{ $t('branches.country') }}</label>
                        <div class="col-sm-5">
                            <v-select :options="countries"
                                      :value="form.country_id"
                                      @input="countryChange"
                                      label="label"
                                      :placeholder="$t('branches.country_placeholder')"
                                      v-model="countrySelected"
                                      name="country_id"
                                      id="country_id"
                                      v-validate="'required'"
                                      style="height: 35px;">
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        <span>{{ option.label }}</span>
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        <span>{{ option.label }}</span>
                                    </div>
                                </template>
                            </v-select>
                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('country_id')"/>
                                <span v-show="errors.has('country_id')">{{ errors.first('country_id') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label">{{ $t('branches.status') }}</label>
                        <div class="col-sm-5">
                            <c-switch :value="true" class="mx-1" color="success"
                                      v-model="form.status"
                                      variant="pill">
                            </c-switch>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-sm-6">
            <div slot="footer">
                <img src="/images/loading.svg" v-if="loading" width="40px"/>
                <button
                        @click="validateBeforeSubmit"
                        class="btn btn-success"
                        type="submit"
                        v-if="!loading && $can('update', 'branches') && $can('create', 'branches')">
                    <font-awesome-icon :icon="['fas', 'dot-circle']"/>
                    {{ $t('global.buttons.submit') }}
                </button>
                <router-link :to="{ name: 'BranchesList' }" v-if="!loading">
                    <button class="btn btn-danger" type="reset">
                        {{ $t('global.buttons.cancel') }}
                    </button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
  import { API } from './../../api'
  import { Switch as cSwitch } from '@coreui/vue'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    components: {
      cSwitch,
      vSelect
    },
    data: () => {
      return {
        loading: false,
        formAction: 'post',
        countries: [],
        countrySelected: null,
        pendingCountryId: null,
        form: {
          code: '',
          description: '',
          country_id: '',
          status: true
        }
      }
    },
    mounted: function () {
      this.loadCountries()

      if (this.$route.params.id !== undefined) {
        API.get('/branches/' + this.$route.params.id)
          .then((result) => {
            if (result.data.success) {
              let branch = result.data.data
              this.formAction = 'put'
              this.form.code = branch.code
              this.form.description = branch.description
              this.form.country_id = branch.country_id
              this.form.status = (branch.status == 1)
              // Set country after countries are loaded
              this.pendingCountryId = branch.country_id
              this.trySetCountry()
            }
          })
      }
    },
    methods: {
      loadCountries () {
        let lang = localStorage.getItem('lang') || 'es'
        API.get('/country/selectbox?lang=' + lang)
          .then((result) => {
            if (result.data.data) {
              this.countries = result.data.data.map(c => {
                let name = c.iso
                if (c.translations && c.translations.length > 0) {
                  name = c.translations[0].value
                }
                return {
                  id: c.id,
                  label: name + ' (' + c.iso + ')'
                }
              })
              this.trySetCountry()
            }
          })
      },
      trySetCountry () {
        if (this.pendingCountryId && this.countries.length > 0) {
          this.countrySelected = this.countries.find(c => c.id === this.pendingCountryId) || null
        }
      },
      countryChange (value) {
        if (value) {
          this.form.country_id = value.id
        } else {
          this.form.country_id = ''
        }
      },
      validateBeforeSubmit () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (!this.form.country_id) {
              this.$notify({
                group: 'main',
                type: 'error',
                title: this.$i18n.t('branches.title'),
                text: this.$i18n.t('branches.error.information_complete')
              })
              return
            }
            this.submit()
          } else {
            this.$notify({
              group: 'main',
              type: 'error',
              title: this.$i18n.t('branches.title'),
              text: this.$i18n.t('branches.error.information_complete')
            })
            this.loading = false
          }
        })
      },
      submit () {
        this.loading = true

        let data = {
          code: this.form.code,
          description: this.form.description,
          country_id: this.form.country_id,
          status: this.form.status ? 1 : 0
        }

        API({
          method: this.formAction,
          url: 'branches/' + (this.$route.params.id !== undefined ? this.$route.params.id : ''),
          data: data
        })
          .then((result) => {
            if (result.data.success === false) {
              let errorMsg = ''
              if (result.data.errors) {
                let errors = result.data.errors
                errorMsg = Object.values(errors).flat().join(', ')
              } else {
                errorMsg = result.data.error || 'Error desconocido'
              }
              this.$notify({
                group: 'main',
                type: 'error',
                title: this.$i18n.t('branches.title'),
                text: errorMsg
              })
              this.loading = false
            } else {
              this.$router.push('/branches/list')
            }
          }).catch(() => {
          this.$notify({
            group: 'main',
            type: 'error',
            title: this.$i18n.t('branches.title'),
            text: this.$i18n.t('branches.error.connection_error')
          })
          this.loading = false
        })
      }
    }
  }
</script>

<style lang="stylus">
</style>
